import { render, staticRenderFns } from "./resHeader.vue?vue&type=template&id=501835c4&scoped=true"
import script from "./resHeader.vue?vue&type=script&lang=js"
export * from "./resHeader.vue?vue&type=script&lang=js"
import style0 from "./resHeader.vue?vue&type=style&index=0&id=501835c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501835c4",
  null
  
)

export default component.exports